<template>

  <v-row class="inner-content">
    <v-col>
      <NKWDwhWhitelistTable />
    </v-col>
  </v-row>

</template>

<script>
export default {
  name: 'NKWDwhWhitelist',

  components: {
    NKWDwhWhitelistTable: () => import('@/components/tables/NKWDwhWhitelistTable.vue')
  },
}
</script>
